import { updateReview } from '../../../actions/reviews';
import { get } from 'lodash';

const submitAttendeeReviewForm = (values, dispatch, props) => {
  const { reviewId, accessToken, review } = props;

  dispatch(updateReview(reviewId, accessToken, values, () => {
    analyticsIntegrations.trackEvent('review_form_submitted', review);

    const { use_type, booking_id, booking, reviewer_id } = review;
    const activity = get(booking, 'tags.activity', '');
    const useTypeObj = {
      'Off-Site': 'meetings',
      Production: 'production',
      Event: 'events'
    };

    let urlDomain = 'book.peerspace.com';
    if ('test' === process.env.NODE_ENV || 'development' === process.env.NODE_ENV) {
      urlDomain = 'peerspace.webflow.io';
    }

    location.href = `https://${urlDomain}/reviews/${useTypeObj[use_type]}?bkg=${booking_id}&role=attendee&activity=${activity}&sso=${reviewer_id}&review=${reviewId}`;
  }));
};

export default submitAttendeeReviewForm;
